import Slider from "react-slick";
import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {Helmet} from 'react-helmet';
import Faqs from "../Page/Faqs";
import Newsletter from "../Page/Newsletter";
import PopularHotels from "../Page/Hotels/Component/PopularHotels";
import PopularFlights from "../Page/PopularFlights";
import FlightsWidgit from "../Page/FlightsWidgit";
import Badge from "../Page/Badge";


function App1() {
  return (
   <>
    <Helmet>     
  <title>Disclaimer, Lowest Airfare and offers | cheapflightsprices.com</title>
  <meta name="description" content="Find Cheap Flight Tickets at cheapflightsprices.com. Also Get best deals online for your summer vacation. Book your flight tickets in advance to avail the best discounts. Hurry up! Offer is valid for limited time"/>
  <meta name="keywords" content="Cheapflightsprices, Cheap Flights Prices,cheap flight booking, cheap flight fares,flight booking offer,Cheap Flights Prices,cheapest ticket booking" />
<meta property="og:description" content="Find Cheap Flight Tickets at cheapflightsprices.com. Also Get best deals online for your summer vacation. Book your flight tickets in advance to avail the best discounts. Hurry up! Offer is valid for limited time" />
<meta property="og:site_name" content="Cheap Flights Prices, Lowest Airfare and offers | cheapflightsprices.com" />
<meta name="twitter:title" content="Cheap Flights Prices, Lowest Airfare and offers | cheapflightsprices.com" />
<meta name="twitter:description" content="Find Cheap Flight Tickets at cheapflightsprices.com. Also Get best deals online for your summer vacation. Book your flight tickets in advance to avail the best discounts. Hurry up! Offer is valid for limited time" />
<meta name="Distribution" content="Global" />
<meta name="Robots" content="follow, index, all" />
<meta name="googlebot" content="index, follow" />
<meta http-equiv="Expires" content="never" />
<meta name="document-type" content="public" />
<meta name="revisit-after" content="daily" />
<meta name="country" content="India" />
<meta name="Language" content="English" />
<meta name='rating' content="general" />
<meta name="author" content="cheapflightsprices.com" />
<link rel="canonical" href="https://cheapflightsprices.com/disclaimer.html" />
  </Helmet>
   <section id="banner_section" className="innerbannersection">
    <div className="hero-container" data-aos="zoom-in" data-aos-delay="100">
      <h1 className="mb-2 pb-0">Cheap Flight Tickets</h1>
      <h2>Cheap Flights Prices Booking Start @ $24</h2>
      <FlightsWidgit/>
    </div>
  </section>
<Badge/>
 

    <main id="main">
    <section id="mainsection" className="section-with-bg">
      <div class="container" data-aos="fade-up">
  <div class="section-header">
    <h2><strong>Disclaimer</strong></h2>
  </div>
  <div class="designcontainer">

    <p>
      CheapFlightsPrices.com provides a travel search and booking facilitation service on an <strong>“as is”</strong> basis. 
      We make no warranties regarding the accuracy, completeness, or suitability of the information provided for your specific travel needs.
    </p>

    <p>
      All flight and hotel data displayed on this website is sourced from our partners. We do not validate this data for accuracy, availability, or compatibility with your requirements, visa status, or citizenship. 
      Prices, fees, and charges may vary and are determined by the partner you book with.
    </p>

    <p>
      We disclaim responsibility for any issues arising from your actions based on information from this website. 
      Booking, payments, refunds, and customer service are handled entirely by the third-party provider.
    </p>

    <p>
      The price shown on our website may not include all applicable charges, such as airport fees, fuel surcharges, departure taxes, baggage fees, or credit card processing fees. 
      We cannot guarantee your satisfaction with flights, hotels, or other services, as the provisioning of service is beyond our control.
    </p>

    <p>
      Our website may occasionally experience downtime or become unresponsive. We are not liable for any inconvenience caused during such periods.
    </p>

    <h4>Affiliate Disclosure</h4>
    <p>
      CheapFlightsPrices.com participates in affiliate programs. We may earn a commission when you complete a booking via links on our website. 
      This does not affect the price you pay and does not make us the seller of travel services.
    </p>

    <p>
      By using this website, you agree to this disclaimer. We may update this disclaimer at any time without prior notice.
    </p>

  </div>
</div>

    </section>
    <PopularFlights/>
        <PopularHotels />
    <Faqs/>
    <Newsletter/>
      </main>
    </>
  );
}
export default App1;
